<template>
    <div class="patient_info_value grid-item c_selector">
        <v-select
            v-model="item.values"
            :key="item.index"
            :options="item.keyRange"
            :get-option-label="computedLabel"
        >
          <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
        </v-select>
    </div>
</template>
<script>
    export default {
        name: 'UnitSelectBox',
        props: ['item'],

        data() {
            return {}
        },
        computed: {
            computedLabel() {
                return (option) => {
                    if (option.unit === 'unit.passive.unit') {
                        return `${this.$t(option.unit)} ${option.title}`;
                    } else if (option.unit === 'unit.assist.assist' || option.unit === 'unit.assist.resist' ||
                        option.unit === 'unit.assist.nature') {
                        return `${this.$t(option.unit)} Level ${option.title}`;
                    } else if (option.unit === 'unit.mins') {
                        return `${option.title} ${this.$t('unit.mins')}`;
                    } else {
                        return option.title
                    }
                }
            }
        }
    }
</script>